import { Box, Card, CircularProgress, Typography } from "@material-ui/core";
import { Dispatch } from "react";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { StateAction } from "./state/actions/actions";
import { StateInterface } from "./state/reducer/store";
import { Editor } from "draft-js";
import "draft-js/dist/Draft.css";
import { config } from "../assets/config";
// import { Editor } from "react-draft-wysiwyg";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
const TextEditor = () => {
  const dispatch: Dispatch<StateAction> = useDispatch();
  const textEditorState = useSelector(
    (state: StateInterface) => state.textEditorState
  );
  const isFileConverting = useSelector(
    (state: StateInterface) => state.isFileConverting
  );
  return (
    <>
      {!isFileConverting && <Card style={{ height: 600, overflow: "auto", width: 1000, margin: 40 }}>
        <Editor
          editorState={textEditorState}
          onChange={(e) =>
            dispatch({ type: "SET_TEXT_EDITOR_STATE", payload: e })
          }
        />


      </Card>}
      {isFileConverting &&
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', margin: '24px 0' }}>
          <Typography variant="caption" style={{ fontSize: 24 }}>
            {config.textByLanguage.en.pleaseBePatient}
          </Typography>
          <CircularProgress size={100} style={{ marginTop: 32 }} />
        </Box>
      }

    </>
  );
};

export default TextEditor;
/* <Editor
  editorState={textEditorState}
  toolbarClassName="toolbarClassName"
  wrapperClassName="wrapperClassName"
  editorClassName="editorClassName"
  onEditorStateChange={(e) =>
    dispatch({ type: "SET_TEXT_EDITOR_STATE", payload: e })}
/> */